import { OpenAPIv3_1 } from '@criteria/openapi'
import { Change, OpenAPI } from './Change'

export class UpdateInfoTitle extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.title = this.value
  }
}

export class UpdateInfoSummary extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    const openAPI3_1 = document as OpenAPIv3_1
    openAPI3_1.info.summary = this.value
  }
}

export class UpdateInfoVersion extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.version = this.value
  }
}

export class UpdateInfoDescription extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.description = this.value
  }
}

export class UpdateInfoTermsOfService extends Change {
  constructor(readonly value: string) {
    super()
  }
  apply(document: OpenAPI): void {
    document.info.termsOfService = this.value
  }
}
